import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GlobalSettingsState } from './global-settings.reducer';

export const selectGlobalSettingsFeature =
  createFeatureSelector<GlobalSettingsState>('global-settings');

export const selectUserConfigForm = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.userConfigForm
);

export const selectHasUserGlobalAdminAccess = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.hasUserGlobalAdminAccess
);

export const selectAllGlobalAdmins = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.globalAdminsIds
);

export const selectAllExceptions = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.exceptionsIds
);

export const selectReleaseEmailResult = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.releaseEmailResult
);
